module.exports = __webpack_public_path__ + "img/ls_dt_l_t_2.3f573549.gif";